// Ana modüller
import { cacheActions } from './actions'
import { cacheServices } from './services'
import { cacheStorage } from './storage'
import { cacheComposables } from './composables'

// Kullanım kolaylığı için kestirme exports
import { 
  get, 
  set, 
  has, 
  invalidate, 
  invalidateByPrefix, 
  clear, 
  getStats 
} from './actions'

import { 
  keyBuilderService, 
  ttlService, 
  cacheHelpers 
} from './services'

import { 
  useCachedData 
} from './composables'

/**
 * Cache servis sınıfı
 */
class CacheService {
  constructor() {
    // İlk başlatma sırasında global istatistikleri ayarla
    if (typeof window !== 'undefined') {
      window.__CACHE_STATS__ = {
        hits: 0,
        misses: 0,
        sets: 0,
        invalidations: 0
      }
    }
  }

  // Action'lar
  get = get
  set = set
  has = has
  invalidate = invalidate
  invalidateByPrefix = invalidateByPrefix
  clear = clear
  getStats = getStats

  // Yardımcı servisler 
  keyBuilder = keyBuilderService
  helpers = cacheHelpers
  
  // Yardımcı metotlar
  cachedFetch = cacheHelpers.cachedFetch
  requestDebouncer = cacheHelpers.requestDebouncer
  
  /**
   * Debug modunu ayarlar
   * @param {boolean} enabled - Debug modu açık/kapalı
   */
  setDebug(enabled) {
    this._debug = enabled
  }
  
  /**
   * Varsayılan TTL değerini ayarlar
   * @param {string|number} ttl - Yeni varsayılan TTL değeri
   */
  setDefaultTTL(ttl) {
    // TTL'i doğrula
    ttlService.parse(ttl) // Hatalıysa exception fırlatır
    this._defaultTTL = ttl
  }
  
  /**
   * İstatistikleri sıfırlar
   */
  resetStats() {
    if (typeof window !== 'undefined') {
      window.__CACHE_STATS__ = {
        hits: 0,
        misses: 0,
        sets: 0,
        invalidations: 0
      }
    }
  }
}

/**
 * Uygulama genelinde kullanılabilen singleton cache servisi
 */
export const cacheService = new CacheService()

// Modül ve alt modülleri dışa aktarma
export {
  // Ana modüller
  cacheActions,
  cacheServices,
  cacheStorage,
  cacheComposables,
  
  // Kestirmeler
  get,
  set,
  has,
  invalidate,
  invalidateByPrefix,
  clear,
  getStats,
  
  // Yardımcı servisler
  keyBuilderService,
  ttlService,
  cacheHelpers,
  
  // Composables
  useCachedData
}